// URL parsers normalize backslashes and strip control characters. Reject them
// before a user-supplied return path reaches location.replace or an OAuth URL.
const unsafeCharacters = value => Array.from(value).some(character => character === '\\' || character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127);
export default function safeLocalReturnPath(value) {
  const candidate = String(value || '');
  let decoded = candidate;
  for (let depth = 0; depth < 4; depth += 1) {
    if (!decoded.startsWith('/') || decoded.startsWith('//') || unsafeCharacters(decoded)) return null;
    try { const next = decodeURIComponent(decoded); if (next === decoded) break; decoded = next; } catch { return null; }
  }
  if (unsafeCharacters(decoded) || decoded.startsWith('//')) return null;
  if (!candidate.startsWith('/') || candidate.startsWith('//') || candidate.includes('\\')) return null;
  if (Array.from(candidate).some(character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) return null;
  return candidate.slice(0, 2048);
}
